import {
  getBookingsData,
  downloadBookingsData,
  bookingEnabledData,
  acceptBookingData
} from '../libs/apis/BookingApi';

export const GET_BOOKING_REQUEST = 'GET_BOOKING_REQUEST';
export const GET_BOOKING_SUCCESS = 'GET_BOOKING_SUCCESS';
export const GET_BOOKING_FAILURE = 'GET_BOOKING_FAILURE';

export const DOWNLOAD_BOOKING_REQUEST = 'DOWNLOAD_BOOKING_REQUEST';
export const DOWNLOAD_BOOKING_SUCCESS = 'DOWNLOAD_BOOKING_SUCCESS';
export const DOWNLOAD_BOOKING_FAILURE = 'DOWNLOAD_BOOKING_FAILURE';

export const EDIT_STATUS_BOOKING_REQUEST = 'EDIT_STATUS_BOOKING_REQUEST';
export const EDIT_STATUS_BOOKING_SUCCESS = 'EDIT_STATUS_BOOKING_SUCCESS';
export const EDIT_STATUS_BOOKING_FAILURE = 'EDIT_STATUS_BOOKING_FAILURE';

export const EDIT_ENABLE_BOOKING_REQUEST = 'EDIT_ENABLE_BOOKING_REQUEST';
export const EDIT_ENABLE_BOOKING_SUCCESS = 'EDIT_ENABLE_BOOKING_SUCCESS';
export const EDIT_ENABLE_BOOKING_FAILURE = 'EDIT_ENABLE_BOOKING_FAILURE';

export const getBookings = params => dispatch => {
  dispatch({ type: GET_BOOKING_REQUEST });
  return getBookingsData(params)
    .then(response =>
      dispatch({
        type: GET_BOOKING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_BOOKING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadBookings = params => dispatch => {
  dispatch({ type: DOWNLOAD_BOOKING_REQUEST });
  return downloadBookingsData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_BOOKING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_BOOKING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const acceptBooking = (idBooking, params) => dispatch => {
  dispatch({ type: EDIT_STATUS_BOOKING_REQUEST });
  return acceptBookingData(idBooking, params)
    .then(response =>
      dispatch({
        type: EDIT_STATUS_BOOKING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_STATUS_BOOKING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const bookingsEnabled = (idShop, params) => dispatch => {
  dispatch({ type: EDIT_ENABLE_BOOKING_REQUEST });
  return bookingEnabledData(idShop, params)
    .then(response =>
      dispatch({
        type: EDIT_ENABLE_BOOKING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_ENABLE_BOOKING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
